'use client'

import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import { Link } from '@/i18n/routing'
import { IconArrowLeft } from '@tabler/icons-react'

interface IdiomNavigationProps {
  previousIdiom: { slug: string; idiom: string } | null
  nextIdiom: { slug: string; idiom: string } | null
}

export function IdiomNavigation({
  previousIdiom,
  nextIdiom
}: IdiomNavigationProps) {
  const t = useTranslations('blog') // Reuse previous/next from blog translations

  if (!previousIdiom && !nextIdiom) {
    return null
  }

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:justify-between">
      {previousIdiom && (
        <Button asChild variant="outline" className="w-full sm:w-auto">
          <Link href={`/read/idioms/${previousIdiom.slug}`}>
            <IconArrowLeft className="mr-2 h-4 w-4" />
            {t('previous')}: {previousIdiom.idiom}
          </Link>
        </Button>
      )}
      {nextIdiom && (
        <Button
          asChild
          variant="outline"
          className="w-full sm:ml-auto sm:w-auto"
        >
          <Link href={`/read/idioms/${nextIdiom.slug}`}>
            {t('next')}: {nextIdiom.idiom}
            <IconArrowLeft className="ml-2 h-4 w-4 rotate-180" />
          </Link>
        </Button>
      )}
    </div>
  )
}
